<template>
	<v-container fluid>
		<v-row>
			<v-col>
				<span class="headline">
					Ордера на оплату
				</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="pa-0">
				<a-data-table
					ref="table"
					v-model="selected"
					:headers="computedHeaders"
					api-path="po/get_list"
					:api-parameters="{
						showAll: showAll
					}"
					disable-sort
					:show-select="showSelect"
					:single-select="false"
					:row-cursor-pointer="!showSelect"
					:initial="{
						search: $route.params.search,
						filters: $route.params.filters
					}"
					@click:row="clickRow"
					@load="onLoad"
					class="pt-2 pb-5"
				>
					<template v-slot:search-append-right>
						<v-menu
							v-model="dropdownMenu"
							:close-on-content-click="false"
							bottom left
						>
							<template v-slot:activator="{ on }">
								<v-btn
									icon
									v-on="on"
									class="mt-1 ml-2"
								>
									<v-icon>more_vert</v-icon>
								</v-btn>
							</template>

							<v-list class="d-print-none">
								<v-list-item v-if="!showSelect" @click="unhideSelect">
									<v-list-item-icon>
										<v-icon style="transform: rotate(90deg)">call_merge</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Соединить ордера
									</v-list-item-title>
								</v-list-item>
								<v-list-item>
									<v-switch
										v-model="showAll"
										dense
									>
										<template v-slot:label>
											<span class="pl-2">
												Показать все
											</span>
										</template>
									</v-switch>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>

					<template v-slot:item.id="{ item }">
						<v-chip
							small
							label
							color="primary"
							:to="{ name: 'PoEntry', params: { id : item.id } }"
						>
							<v-icon small left>credit_card</v-icon>
							{{ item.id }}
						</v-chip>
					</template>
					<template v-slot:item.createdDate="{ item }">
						{{ item.createdDateFormatted }}
					</template>
					<template v-slot:item.authorName="{ item }">
						<span class="text-no-wrap">
							{{ item.authorName }}
						</span>
					</template>
					<template v-slot:item.status="{ item }">
						<v-tooltip left open-delay="500" v-if="item.statusName !== item.statusNameShort">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									{{ item.statusNameShort }}
								</span>
							</template>
							{{ item.statusName }}
						</v-tooltip>
						<span v-else>
							{{ item.statusName }}
						</span>
					</template>
					<template v-slot:item.sumGross="{ item }">
						<div class="text-no-wrap" style="min-width: 60px;">
							{{ item.sumText }}
						</div>
					</template>
					<template v-slot:item.stamps="{ item }">
						<div class="text-no-wrap">
							<v-chip
								small label link
								v-if="item.stamps.approved"
								color="blue"
								text-color="white"
								class="mr-1 mt-1"
							>
								Согласован
							</v-chip>

							<v-chip
								small label link
								v-if="item.stamps.paid"
								color="green"
								text-color="white"
								class="mr-1 mt-1"
							>
								Оплачен
							</v-chip>

							<v-chip
								small label link
								v-if="item.newComments"
								color="blue-grey"
								text-color="white"
								class="mr-1 mt-1"
								@click="checkNewComments(item)"
							>
								...
							</v-chip>
						</div>
					</template>

				</a-data-table>
			</v-col>
		</v-row>
		<v-row v-if="showSelect">
			<v-col>
				<v-btn
					v-intersect="intersectButtons"
					color="primary"
					class="ma-2"
					:disabled="selected.length < 2"
					:loading="mergeLoading"
					@click="confirmMerge"
				>
					Соединить
				</v-btn>
				<v-btn
					v-intersect="intersectButtons"
					color="secondary"
					class="ma-2"
					@click="showSelect = false"
				>
					Отмена
				</v-btn>
			</v-col>
		</v-row>
		<div
			v-if="showSelect && !intersectingButtons"
			class="pa-0 d-print-none"
			style="position: fixed; bottom: 0px;"
		>
			<v-btn
				color="primary"
				class="ma-2"
				:disabled="selected.length < 2"
				@click="confirmMerge"
			>
				Соединить
			</v-btn>
			<v-btn
				color="secondary"
				class="ma-2"
				@click="showSelect = false"
			>
				Отмена
			</v-btn>
		</div>
	</v-container>
</template>

<script>
import aDataTable from '../base/ADataTable.vue'
import {api} from '../../lib/api'
import _ from 'lodash'

export default {
	mixins: [
	],
	components: {
		aDataTable
	},
	data: () => ({
		dropdownMenu: false,
		headers: [
			{
				text: '№',
				value: 'id',
				align: 'center',
				filterable: true,
				filterType: 'number',
			},
			{
				text: 'Дата',
				value: 'createdDate',
				align: 'center',
				filterable: true,
				filterType: 'date',
			},
			{
				text: 'Отель',
				value: 'hotelCode',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Автор',
				value: 'authorName',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Поставщик',
				value: 'supplier',
				align: 'center',
				filterable: false,
				filterType: 'text',
			},
			{
				text: 'Сумма, ₽',
				value: 'sumGross',
				align: 'center',
				filterable: true,
				filterType: 'number',
			},
			{
				text: 'Этап',
				value: 'status',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Отметки',
				value: 'stamps',
				align: 'center',
				filterable: false,
			}
		],
		intersectingButtons: false,
		selected: [],
		showAll: false,
		showSelect: false,
		mergeLoading: false,
		timer: 0,
		scroll: false,
		updateInterval: 300000,	// 5 минут
	}),
	computed: {
		computedHeaders() {
			if (this.$vuetify.breakpoint.xsOnly) {
				return this.headers.filter(h => {
					return h.value == 'supplier'
						|| h.value == 'createdDate'
				})
			}
			else {
				return this.headers
			}
		}
	},
	methods: {
		intersectButtons(entries, observer) {
			this.intersectingButtons = entries[0].isIntersecting
		},
		checkNewComments(row) {
			this.scroll = true
			this.clickRow(row)
		},
		clickRow(row) {
			if (!this.showSelect) {
				this.$router.push({
					name: 'PoEntry',
					params: {
						id: row.id,
						filters: this.$refs.table.filters,
						search: this.$refs.table.search,
						showAll: this.showAll,
						scroll: this.scroll
					}
				})
			}
		},
		confirmMerge() {
			let suppliers = this.selected.map(item => item.supplier)
			suppliers = Array.from(new Set(suppliers))

			// console.log(suppliers)

			if (suppliers.length > 1) {
				this.$store.dispatch('dialogConfirm', {
					title: 'Разные контрагенты',
					message: 'Вы выбрали ордера по разным контрагентам:<br><br>'
						+ suppliers.join(',<br>')
						+ '<br><br>Не рекомендуется соединять ордера по разным контрагентам. Продолжайте, только если разница состоит в написании названия контрагента.'
				})
				.then(confirm => {
					if (confirm) {
						this.merge()
					}
				})
			}
			else {
				this.merge()
			}
		},
		merge() {
			this.mergeLoading = true

			let ids = this.selected.map(item => item.id)

			api.post('po/merge', {
				ids: ids
			})
			.then(response => {
				this.$store.dispatch('dialogNotify', {
					title: 'Ордера соединены',
					message: 'Ордера '
						+ ids.join(', ')
						+ ' соединены в один '
						+ `<router-link :to="{ name: 'PoEntry', params: { id: ${response.data.id} } }">`
						+ `${response.data.id}`
						+ '</router-link>'
				})

				this.mergeLoading = false
				this.showSelect = false
				this.selected = []
				this.$refs.table.clearAndLoad()
			}, error => {
				this.mergeLoading = false
			})
		},
		newPo() {
			this.$router.push('po/new')
		},
		setSelectedRecursive(id, depth, limit) {
			// console.log('setSelectedRecursive')
			if (this.$refs.table.items.length == 0) {
				depth++
				if (depth < limit) {
					setTimeout(() => {
						this.setSelectedRecursive(id, depth, limit)
					}, 500)
				}
			}
			else {
				let row = this.$refs.table.items.find(item => item.id == id)
				this.$refs.table.select(row)
			}
		},
		unhideSelect() {
			this.showSelect = true
			this.dropdownMenu = false
			this.selected = []
		},
		onLoad() {
			this.selected = []
			this.$store.dispatch('loadMenuCounters')
		},
	},
	created() {
		if (this.$route.params.showAll !== undefined) {
			this.showAll = this.$route.params.showAll
		}
	},
	mounted() {
		if (this.$route.params.initialSelected !== undefined) {
			this.showSelect = true
			this.setSelectedRecursive(this.$route.params.initialSelected, 0, 10)
		}

		this.timer = setInterval(() => {
			// console.log('interval function')
			if (!document.hidden) {
				this.$refs.table.clearAndLoad()
			}
		}, this.updateInterval)

		// console.log(window.onfocus)

		window.onfocus = () => {
			// console.log('onfocus')
			this.$refs.table.clearAndLoad()
		}
	},
	destroyed() {
		clearInterval(this.timer)
		window.onfocus = null
	},
}
</script>

<style>
</style>
